import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../store/actions/index";
import _ from "lodash";

import {
  CopyOutlined,
  EditOutlined,
  UsergroupAddOutlined,
  UserOutlined,
  AuditOutlined,
  FileSyncOutlined,
} from "@ant-design/icons";

import { Collapse, Tabs, message, Modal } from "antd";

import FormOne from "../components/UserGrouping/FormOne";
import FormTwo from "../components/UserGrouping/FormTwo";
import FormThree from "../components/UserGrouping/FormThree";
import FormFour from "../components/UserGrouping/FormFour";
import FormFive from "../components/UserGrouping/FormFive";
import FormSix from "../components/UserGrouping/FormSix";
import FormSeven from "../components/UserGrouping/FormSeven";
import TableOne from "../components/UserGrouping/TableOne";
import TableTwo from "../components/UserGrouping/TableTwo";

const { Panel } = Collapse;

const { TabPane } = Tabs;
const { confirm } = Modal;

class UserGrouping extends Component {
  state = {
    loading: false,
    visible: false,
    select: null,
    selected_project: null,
    postEnvelopeData: null,
    businessDate: null,
  };

  async componentDidMount() {
    if (!this.props.api.hotelGetData) {
      await this.props.hotelGet();
    }
    if (!this.props.api.hmgGetData) {
      await this.props.hmgGet();
    }
    if (!this.props.api.hmgMainGetData) {
      await this.props.hmgMainGet();
    }
  }

  // formFourFormRef = React.createRef();

  formOneSaveFormRef = (formRef) => {
    this.formOneFormRef = formRef;
  };
  formTwoSaveFormRef = (formRef) => {
    this.formTwoFormRef = formRef;
  };
  formThreeSaveFormRef = (formRef) => {
    this.formThreeFormRef = formRef;
  };

  // formFourSaveFormRef = formRef => {
  //   console.log(formRef);
  //   this.formFourFormRef = formRef;
  // };
  formFiveSaveFormRef = (formRef) => {
    this.formFiveFormRef = formRef;
  };
  formSixSaveFormRef = (formRef) => {
    this.formSixFormRef = formRef;
  };
  formSevenSaveFormRef = (formRef) => {
    this.formSevenFormRef = formRef;
  };

  formOneSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formOneFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
    });
  };

  formTwoSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formTwoFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let sendValues = {};
      sendValues._id = this.state.select;
      sendValues.grant_access_users = values.grant_access_users;
      // sendValues.signature_group_users = values.signature_group_users;

      if (await this.props.hotelUpdate(sendValues)) {
        form.resetFields();
        await this.props.signersGroupsGet({
          id: this.state.select,
          project_id: this.state.selected_project,
        });
      }
    });
  };

  formThreeSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formThreeFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let sendValues = {};
      sendValues.hotel_id = this.state.select;
      sendValues.signers_group_name = values.signers_group_name;
      sendValues.signers_group_users = values.signers_group_users;

      if (await this.props.signersGroupCreate(sendValues)) {
        form.resetFields();
        await this.props.signersGroupsGet({
          id: this.state.select,
          project_id: this.state.selected_project,
        });
      }
    });
  };

  formFourSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formFourFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      values._id = this.state.select;
      console.log(values);

      // if (await this.props.signersGroupsHotelUpdate(values)) {
      //   // form.resetFields();
      //   await this.props.signersGroupsGet({ id: this.state.select });

      // }

      // let sendValues = {};
      // sendValues.hotel_id = this.state.select;
      // sendValues.signers_group_name = values.signers_group_name;
      // sendValues.signers_group_users = values.signers_group_users;

      // if (await this.props.signersGroupCreate(sendValues)) {
      //   form.resetFields();
      //   await this.props.signersGroupsGet({ id: this.state.select });

      // }
    });
  };

  formFiveSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formFiveFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let sendValues = {};
      sendValues._id = this.state.select;
      sendValues.signature_cc_recepients_users =
        values.signature_cc_recepients_users;
      // sendValues.signature_group_users = values.signature_group_users;

      if (await this.props.hotelUpdate(sendValues)) {
        form.resetFields();
        await this.props.signersGroupsGet({
          id: this.state.select,
          project_id: this.state.selected_project,
        });
      }
    });
  };

  formFourOnFinish = async (values) => {
    // console.log('Success:', values);
    values._id = this.state.select;
    // console.log(values);
    if (await this.props.signersGroupsHotelUpdate(values)) {
      await this.props.signersGroupsGet({
        id: this.state.select,
        project_id: this.state.selected_project,
      });
    }
  };

  formFourOnFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  formSixSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formSixFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      values.hotel_id = this.state.select;

      if (await this.props.outOfOfficeCreate(values)) {
        form.resetFields();
        form.setFieldsValue({ out_of_office_duration: null });
        await this.props.signersGroupsGet({
          id: this.state.select,
          project_id: this.state.selected_project,
        });
      }

      // console.log(values, "form Six");
    });
  };

  formSevenSubmit = (e) => {
    e.preventDefault();
    const { form } = this.formSevenFormRef.props;

    form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      let envelopObj = { type: "post", data: [] };

      values.type = "post";
      // console.log(values, "values");

      if (this.state.postEnvelopeData && this.state.postEnvelopeData.length > 0) {
        let additional_initial_group = values.additional_data.initial_groups;
        let groupsArr = values.groups;
        // console.log(additional_initial_group, "adintionalinitialgroup")
        // console.log(groupsArr, "agroupsArr")
        let changedEnvelopeData = [];
        for (const element of this.state.postEnvelopeData) {
          // console.log(element.envelopeRequestId, "element....", element.signers, element.groups)
          let val = { ...values };
          let additional_data = { ...values.additional_data };
          additional_data.indivdual_signers = [...element.signers];
          additional_data.groups = [...element.groups];
          let groupSigners = {};
          let newGroupArr = [];
          additional_data.groups.forEach((aaa, index) => {
            // console.log(aaa.groupId, "aaa.....");
            // console.log(Object.entries(additional_initial_group).find(([key, val]) => key == aaa.groupId)[1]);
            let signersGroup = Object.entries(additional_initial_group).find(([key, val]) => key == aaa.groupId)[1];
            groupSigners[aaa.groupId] = signersGroup;
            // console.log(index, "index..");
            // console.log(groupsArr[index].users, "groupsArr[index].users..");
            newGroupArr.push({ group_id: aaa.groupId, users: groupsArr[index].users });
          });
          additional_data.initial_groups = groupSigners;

          val.groups = newGroupArr;
          val.additional_data = additional_data;
          val.envelope_request_id = element.envelopeRequestId;
          val.business_date = element.date;
          val.envelope_subject = this.state.postEnvelopeData[0].envelopeSubject;
          console.log(val, "values.....")
          changedEnvelopeData.push(val);

        }
        envelopObj.data = changedEnvelopeData;
        // console.log(changedEnvelopeData, "postenvel...", envelopObj)
        let postEnvelopeResult = await this.props.postEnvelope(envelopObj);
        // console.log("postEnvelopeResult", postEnvelopeResult);
        if (postEnvelopeResult && postEnvelopeResult.data) {
          if (!postEnvelopeResult.data.error) {
            if (postEnvelopeResult.data.message) {
              let msg = "";
              let dbMsg = _.uniq(postEnvelopeResult.data.message);
              // console.log(dbMsg, "Msg");
              dbMsg.forEach((m) => {
                msg = msg + m + "\n";
              });
              message.success(msg);
              this.setState({ postEnvelopeData: null, businessDate: null });
              form.setFieldsValue({ business_date: null });
            }
          } else {
            let msg = "";
            let dbMsg = _.uniq(postEnvelopeResult.data.message);
            dbMsg.forEach((m) => {
              msg = msg + m + "\n";
            });
            message.error(msg);
          }
        }
      }

      // let sendValues = {};
      // sendValues._id = this.state.select;
      // sendValues.grant_access_users = values.grant_access_users;
      // sendValues.signature_group_users = values.signature_group_users;

      // if (await this.props.hotelUpdate(sendValues)) {
      //   form.resetFields();
      //   await this.props.signersGroupsGet({ id: this.state.select });
      // }
    });
  };

  deleteSigners = async (value) =>{    
    if (this.state.postEnvelopeData && this.state.postEnvelopeData.length > 0) {
      let deleteEnvData = [];
      const { form } = this.formSevenFormRef.props;
      for (const element of this.state.postEnvelopeData) {
        if(value.signerIds){    
          let signerList = [];      
          for(const signer of value.signerIds){
            // console.log(_.find(element.signers, function(e){ return signer === e.sm_id}).signerId, "signer")
            signerList.push(_.find(element.signers, function(e){ return signer === e.sm_id}).signerId);
          }
          deleteEnvData.push({"envReqId": element.envelopeRequestId, "signers": {"signerIds":signerList}});
        }else if(value.groupId){
          let groupList = [];
          // console.log(value.groupId, "value.groupId");
          // console.log(element.groups, "value.groupId");
          groupList = _.find(element.groups, function(e){ return value.groupId === e.name}).groupId;
          deleteEnvData.push({"envReqId": element.envelopeRequestId, "group": {"groupId": groupList}});
        }
        
      }
      // console.log(deleteEnvData, "deleteenvdata");
      let deletedSignerData = await this.props.deleteSigners({deleteEnvData, vendor: this.state.postEnvelopeData[0].vendor});
      // console.log(deletedSignerData, "deleted signer data");
      if (deletedSignerData) {
        if(!deletedSignerData.error){
          let dbMsg = _.uniq(deletedSignerData.message);
          if(dbMsg == "ok"){
            message.success(value.groupId + " group successfully deleted.");
          }else{
            message.success(dbMsg);
          }
          this.setState({ postEnvelopeData: null, businessDate: null });
          form.setFieldsValue({ business_date: null });
        }else{
          let dbErrorMsg = _.uniq(deletedSignerData.message);
          message.error(dbErrorMsg);
        }       
      }
    }
  }

  foremOneHotelOnChange = async (value, hmgIdValue) => {
    // console.log(value, "aaaaaaaaaaaaaaaaaa");
    this.setState({ select: value });

    // await this.props.reportsGet({ id: value });
    await this.props.signersGroupsGet({ id: value, project_id: hmgIdValue });
    if (this.formTwoFormRef) {
      this.formTwoFormRef.props.form.resetFields();
    }
    if (this.formThreeFormRef) {
      this.formThreeFormRef.props.form.resetFields();
    }
    if (this.formFiveFormRef) {
      this.formFiveFormRef.props.form.resetFields();
    }
    if (this.formSixFormRef) {
      this.formSixFormRef.props.form.resetFields();
      this.formSixFormRef.props.form.setFieldsValue({
        out_of_office_duration: null,
      });
    }
    if (this.formSevenFormRef) {
      this.setState({ postEnvelopeData: null, businessDate: "changed" });
    }
  };

  formOneHmgMainIdOnChange = () => {
    this.setState({ select: null });
  };
  formOneHmgIdOnChange = (value) => {
    this.setState({ select: null, selected_project: value });
  };
  setFormTwoValues = (value) => { };

  saveGroup = async (values) => {
    let sendValues = {};
    sendValues._id = values._id;
    sendValues.hotel_id = this.state.select;
    sendValues.signers_group_name = values.signers_group_name;
    sendValues.signers_group_users = values.signers_group_users;
    if (await this.props.signersGroupUpdate(sendValues)) {
      await this.props.signersGroupsGet({
        id: this.state.select,
        project_id: this.state.selected_project,
      });
      return true;
    } else {
      return false;
    }
  };

  updateOutOfOffice = async (values) => {
    let sendValues = {};
    sendValues._id = values._id;
    sendValues.hotel_id = this.state.select;
    sendValues.out_of_office_assigner = values.assigner;
    sendValues.out_of_office_assignee = values.assignee;
    sendValues.out_of_office_duration = values.duration;
    if (await this.props.outOfOfficeUpdate(sendValues)) {
      await this.props.signersGroupsGet({
        id: this.state.select,
        project_id: this.state.selected_project,
      });
      return true;
    } else {
      return false;
    }
  };

  deleteOutOfOffice = async (values) => {
    let sendValues = {};
    sendValues.hotel_id = this.state.select;
    sendValues.delete_id = values;
    console.log(sendValues);

    if (await this.props.outOfOfficeUpdate(sendValues)) {
      await this.props.signersGroupsGet({
        id: this.state.select,
        project_id: this.state.selected_project,
      });
    }

    // let sendValues = {};
    // sendValues._id = values._id;
    // sendValues.hotel_id = this.state.select;
    // sendValues.out_of_office_assigner = values.assigner;
    // sendValues.out_of_office_assignee = values.assignee;
    // sendValues.out_of_office_duration = values.duration;
    // if (await this.props.outOfOfficeUpdate(sendValues)) {
    //   await this.props.signersGroupsGet({ id: this.state.select });
    //   return true;
    // } else {
    //   return false;
    // }
  };

  showConfirm = (data, dateRange) => {
    const { form } = this.formSevenFormRef.props;
    confirm({
      title: 'Signers are different for the selected date range.',
      content: 'Signers are the same for ' + dateRange + '. Do you want to proceed?',
      okText: 'Yes',
      cancelText: 'No',
      icon:null,
      onOk: () => {
        this.setState({ postEnvelopeData: data });
      },
      onCancel: () => {
        this.setState({ postEnvelopeData: null, businessDate: null });
        form.setFieldsValue({ business_date: null });
      },
    });
  }
  businessDateOnChange = async (date, dateString) => {
    if (date != null) {
      const postEnvelopeResult = await this.props.postEnvelope({
        type: "get",
        hotel_id: this.state.select,
        date: dateString,
      });
      if (this.formSevenFormRef && this.formSevenFormRef.props) {
        this.formSevenFormRef.props.form.resetFields();
      }

      if (
        postEnvelopeResult &&
        postEnvelopeResult.data &&
        postEnvelopeResult.data.data
      ) {
        if (postEnvelopeResult.data.rangeDiff) {
          let dateR = postEnvelopeResult.data.data[0].date + " to " + postEnvelopeResult.data.data[postEnvelopeResult.data.data.length - 1].date;
          this.showConfirm(postEnvelopeResult.data.data, dateR);
          this.setState({ businessDate: date });
        } else {
          this.setState({ postEnvelopeData: postEnvelopeResult.data.data, businessDate: date });
        }
      } else {
        this.setState({ postEnvelopeData: null, businessDate: null });
      }
    } else {
      this.setState({ postEnvelopeData: null, businessDate: null });
    }
  };

  render() {
    return (
      <div>
        <div className="container_ab">
          <div className="container_style_2">
            <Collapse defaultActiveKey={["1_1"]} expandIconPosition="end">
              <Panel header="Envelope Signers" key="1_1" arrow="right">
                <div className="is_form_1">
                  {this.props.api.hotelGetData &&
                    this.props.api.hmgGetData &&
                    this.props.api.hmgMainGetData ? (
                    <FormOne
                      wrappedComponentRef={this.formOneSaveFormRef}
                      onSubmit={this.formOneSubmit}
                      foremOneHotelOnChange={this.foremOneHotelOnChange}
                      formOneHmgIdOnChange={this.formOneHmgIdOnChange}
                      formOneHmgMainIdOnChange={this.formOneHmgMainIdOnChange}
                      hotelGetData={this.props.api.hotelGetData.data}
                      hmgGetData={this.props.api.hmgGetData.data}
                      hmgMainGetData={this.props.api.hmgMainGetData.data}
                    />
                  ) : null}
                </div>
              </Panel>
            </Collapse>

            <div style={{ marginBottom: 20 }}></div>
            {this.props.api.signersGroupsGetData && this.state.select ? (
              <Collapse defaultActiveKey={["2_1"]} expandIconPosition="end">
                <Panel header="Envelope Signers" key="2_1" arrow="right">
                  <Tabs defaultActiveKey="tab_1_2">
                    <TabPane
                      tab={
                        <span>
                          <UserOutlined />
                          Grant Access
                        </span>
                      }
                      key="tab_1_1"
                    >
                      <FormTwo
                        onSubmit={this.formTwoSubmit}
                        wrappedComponentRef={this.formTwoSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                      />
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <UsergroupAddOutlined />
                          Manage Group
                        </span>
                      }
                      key="tab_1_2"
                    >
                      <FormThree
                        onSubmit={this.formThreeSubmit}
                        wrappedComponentRef={this.formThreeSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                      />

                      {this.props.api.signersGroupsGetData.data &&
                        this.props.api.signersGroupsGetData.data.signers_groups
                          .length > 0 ? (
                        <TableOne
                          signersGroupsGetData={
                            this.props.api.signersGroupsGetData.data
                          }
                          saveGroup={this.saveGroup}
                        />
                      ) : null}
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <EditOutlined />
                          Manage Signature
                        </span>
                      }
                      key="tab_1_3"
                    >
                      <FormFour
                        onFinish={this.formFourOnFinish}
                        onFinishFailed={this.formFourOnFinishFailed}
                        // formRef={this.formFourFormRef}
                        formRef={this.formFourSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                      />
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <CopyOutlined />
                          Manage CC Recipients
                        </span>
                      }
                      key="tab_1_4"
                    >
                      <FormFive
                        onSubmit={this.formFiveSubmit}
                        wrappedComponentRef={this.formFiveSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                      />
                    </TabPane>
                    <TabPane
                      tab={
                        <span>
                          <AuditOutlined />
                          Out of Office
                        </span>
                      }
                      key="tab_1_5"
                    >
                      <FormSix
                        onSubmit={this.formSixSubmit}
                        wrappedComponentRef={this.formSixSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                      />

                      {this.props.api.signersGroupsGetData.data.out_of_office &&
                        this.props.api.signersGroupsGetData.data.out_of_office
                          .length > 0 ? (
                        <TableTwo
                          signersGroupsGetData={
                            this.props.api.signersGroupsGetData.data
                          }
                          saveGroup={this.updateOutOfOffice}
                          delete={this.deleteOutOfOffice}
                        />
                      ) : null}
                    </TabPane>

                    <TabPane
                      tab={
                        <span>
                          <FileSyncOutlined />
                          Post Envelope
                        </span>
                      }
                      key="tab_1_6"
                    >
                      <FormSeven
                        onSubmit={this.formSevenSubmit}
                        businessDateOnChange={this.businessDateOnChange}
                        wrappedComponentRef={this.formSevenSaveFormRef}
                        signersGroupsGetData={
                          this.props.api.signersGroupsGetData.data
                        }
                        postEnvelopeData={this.state.postEnvelopeData}
                        businessDate={this.state.businessDate}
                        deleteSigners={this.deleteSigners}
                      />
                    </TabPane>
                  </Tabs>
                </Panel>
              </Collapse>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => ({
  hotelGet: () => dispatch(actions.hotelGet()),
  hmgGet: () => dispatch(actions.hmgGet()),
  hmgMainGet: () => dispatch(actions.hmgMainGet()),
  reportsGet: (data) => dispatch(actions.reportsGet(data)),
  signersGroupsGet: (data) => dispatch(actions.signersGroupsGet(data)),
  signersGroupCreate: (data) => dispatch(actions.signersGroupCreate(data)),
  signersGroupUpdate: (data) => dispatch(actions.signersGroupUpdate(data)),
  signersGroupsHotelUpdate: (data) =>
    dispatch(actions.signersGroupsHotelUpdate(data)),
  outOfOfficeCreate: (data) => dispatch(actions.outOfOfficeCreate(data)),
  outOfOfficeUpdate: (data) => dispatch(actions.outOfOfficeUpdate(data)),
  postEnvelope: (data) => dispatch(actions.postEnvelope(data)),
  deleteSigners: (data) => dispatch(actions.deleteSigners(data)),

  hotelUpdate: (data) => dispatch(actions.hotelUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserGrouping);
